import { Sentiment } from "contexts/WasThisHelpfulContext";

import { getRecaptchaToken } from "utils/recaptcha";
import { FEEDBACK_ENDPOINT } from "utils/url";

type FeedbackBannerEvent = {
    feedback_type: "feedback_banner";
    feedback: string;
};

type WTAHYesNoClickEvent = {
    feedback_type: "yes_no_click";
    sentiment: Sentiment;
};

type WTAHReasonEvent = {
    feedback_type: "reason";
    reason: string;
    sentiment: Sentiment;
};

type WTAHCommentEvent = {
    feedback_type: "comment";
    sentiment: Sentiment;
    reason: string;
    feedback: string;
    email?: string;
};

type NPSRatingEvent = {
    feedback_type: "nps_rating";
    rating: number;
};

type NPSCommentEvent = {
    feedback_type: "nps_comment";
    rating: number;
    comment: string;
};

type SendFeedbackEventProps =
    | FeedbackBannerEvent
    | WTAHYesNoClickEvent
    | WTAHReasonEvent
    | WTAHCommentEvent
    | NPSRatingEvent
    | NPSCommentEvent;

export const sendFeedbackEvent = async (
    recaptchaAction: string,
    props: SendFeedbackEventProps
) => {
    const body = Object.fromEntries(
        Object.entries(props).filter(
            (pair) => typeof pair[1] !== "undefined" && pair[1] !== null
        )
    );

    const userAgent = navigator.userAgent;

    const requestBody: Record<string, any> = {
        ...body,
        url: window.location.href,
        page_title: document.title,
        user_agent: userAgent,
    };

    // recaptcha doesn't work on firefox
    if (!userAgent.includes("Firefox")) {
        const token = await getRecaptchaToken(recaptchaAction);

        requestBody.recaptcha_token = token;
        requestBody.recaptcha_action = recaptchaAction;
    }

    return fetch(FEEDBACK_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
    }).catch((error) => {
        console.error(error);
    });
};
